import React from 'react';

import DismissablePromotionDone from '../DismissablePromotionDone';

type Props = {
  persistId: string;
  version: string;
};

function Done(props: Props) {
  const { persistId, version } = props;
  return <DismissablePromotionDone persistId={persistId} version={version} />;
}

export default Done;
